import { useFindAllActivities } from "~/gen/api"
import { useFindOperationChainsQuery } from "~/pages/Admin/Ingestion/OpChains/hooks/useFindOperationChainsQuery"

export function useOpChainsQueries() {
  const {
    data: activities,
    isLoading: activitiesLoading,
    isError: activitiesError,
  } = useFindAllActivities()
  const {
    data: opChains,
    isLoading: opChainLoading,
    isError: opChainError,
  } = useFindOperationChainsQuery({})

  if (activitiesLoading || opChainLoading) {
    return { isLoading: true }
  }

  if (activitiesError || opChainError) {
    return { isError: true }
  }

  return { activities, opChains }
}
